<template>
  <tenant-sidebar-shell :collapsed="collapsed" @toggle="$emit('toggle')">
    <el-menu
      class="tenant-sidebar-menu"
      unique-opened
      mode="vertical"
      background-color="#fff"
      text-color="#606266"
      active-text-color="var(--tenant-theme-color)"
      :router="router"
      :default-active="activeIndex"
      :collapse="collapsed"
      @select="handleSelect"
    >
      <slot />
    </el-menu>
  </tenant-sidebar-shell>
</template>

<script>
import TenantSidebarShell from '@/components/TenantSidebarShell/index.vue'

export default {
  name: 'TenantSidebarMenu',
  components: {
    TenantSidebarShell
  },
  props: {
    collapsed: {
      type: Boolean,
      default: false
    },
    activeIndex: {
      type: String,
      default: ''
    },
    router: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.$emit('select', key, keyPath)
    }
  }
}
</script>
